import request from './request'

export function wxshareApi(query) {
    return request({
        url:'/huhushare/Share/getWechatShare',
        method: 'post',
        data: query
    });
}

export function getShareContent(query) {
    return request({
        url:'/huhushare/Share/getShareContent',
        method: 'post',
        data: query
    });
}

export function getShareSsoData(query) {
    return request({
        url:'/huhushare/Share/getShareSsoData',
        method: 'post',
        data: query
    });
}